<template>
  <vs-table :data="data">
    <template slot="thead">
      <th-sort :text="$t('vendor')"         column="Vendors.VendorName" @sort="handleClickSort"/>
      <th-sort :text="$t('rfc')"         column="Vendors.rfc" @sort="handleClickSort"/>
      <th-sort :text="$t('client')"         column="cl.ClientName" @sort="handleClickSort"/>
      <th-sort :text="$t('since')"         column="Vendors.appears_since" @sort="handleClickSort"/>
    </template>
    <template slot-scope="{ data }">
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
        <vs-td class="text-left">
          {{ data[indextr].vendor_name }}
        </vs-td>
        <vs-td class="text-left">
          {{ data[indextr].vendor_rfc }}
        </vs-td>
        <vs-td class="text-left">
          {{ data[indextr].client_name }}
        </vs-td>
        <vs-td class="text-left">
          {{ data[indextr].appears_since }}
        </vs-td>
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div v-if="data.length" v-observe-visibility="infiniteHandler"></div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>
<script>
import ThSort from '@/views/components/ThSort.vue'

export default {
  components:{
    ThSort
  },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    infiniteHandler(isVisible) {
      if (!isVisible) { return }
      this.$emit('loadMore')
    },
    handleClickSort(e){
      this.$emit('sort',e)
    }
  }
}

</script>
<style>
.qb-sticky {
  background: white;
  position: sticky;
  top: 0;
}

</style>
